import { useState } from "react";
import Spinner from "../../components/others/Spinner/Spinner";
import LavorisService from "../../services/LavorisService";
import { useAlert } from "../../hooks/useAlert";
import { useNavigate } from "react-router-dom";
import { getErrorMessage } from "../../utils";

const UpdateUserLoggedInPassword = () => {
  const LavorisInstance = LavorisService.getInstance();
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const [loadingButton, setLoadingButton] = useState(false);
  const updateUserLoggedInPassword = async () => {
    try {
      setLoadingButton(true);
      const res = await LavorisInstance.User.updateUserLoggedInPassword();
      if (res) {
        navigate(`/Alta/Agregar-password/${res}`);
      }
    } catch (err) {
      showAlert(getErrorMessage({ title: 'Error al redirigir', err }));
    } finally{
      setLoadingButton(false);
    }
  }

  return (
    <div>
      {!loadingButton && (
        <button
        type="button"
        onClick={() => updateUserLoggedInPassword()}
        className="inline-flex items-center justify-center rounded-md bg-red-600 px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-red-700 transition-colors"
      >
        Confirmar y continuar
      </button>
      )}        
      {loadingButton && (
        <button className="inline-flex items-center justify-center rounded-md bg-red-300 px-3 py-1.5 text-sm font-semibold text-white shadow-sm transition-colors">
          <h2 className="text-lg">
            <Spinner/>
          </h2>
        </button>
      )}
    </div>
  )
}

export default UpdateUserLoggedInPassword;